import React, { Component } from "react";

class Button extends Component {
  title = "";
  type = "";
  url = "#";
  href = "";

  state = {
    active: false,
  };

  sendButtonResponse = () => {
    this.props.onSubmitButtonResponse(this.props.title);
    this.setState({ active: true });
  };

  getLastUserMessage = () => {
    return sessionStorage.getItem("lastUserMessageValue");
  };

  render() {
    return (
      <a
        href={
          this.props.type === "INPUT_BUTTON"
            ? this.props.href
            : this.props.href + "&pk_kwd=" + this.getLastUserMessage()
        }
        title={this.props.title}
        className={`btn ${this.props.type}`}
        // target={this.props.type === "LINK_BUTTON" ? "_blank" : null}
        onClick={
          this.props.type === "INPUT_BUTTON" ? this.sendButtonResponse : null
        }
      >
        {this.props.title}
      </a>
    );
  }
}

export default Button;
